import { notifications } from '@mantine/notifications';
import { useState } from 'react';
import './ModalAvaliacao.css';

const ModalAvaliacao = ({ appointment, onClose, onSubmit }) => {
    const [rating, setRating] = useState(0);
    const [hover, setHover] = useState(0);
    const [comment, setComment] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (rating === 0) {
            notifications.show({
                title: 'Atenção',
                message: 'Por favor, selecione uma nota.',
                color: 'orange'
            });
            return;
        }

        setIsSubmitting(true);
        try {
            await onSubmit(appointment.id, {
                rating,
                review: comment,
                reviewedAt: new Date().toISOString()
            });
            onClose();
        } catch (error) {
            console.error('Erro ao enviar avaliação:', error);
            notifications.show({
                title: 'Erro',
                message: 'Erro ao enviar avaliação. Tente novamente.',
                color: 'red'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    const getRatingLabel = (val) => {
        const labels = {
            1: 'Ruim',
            2: 'Regular',
            3: 'Bom',
            4: 'Muito Bom',
            5: 'Excelente'
        };
        return labels[val] || '';
    };

    return (
        <div className="rating-modal-overlay">
            <div className="rating-modal-content fade-in">
                <button className="close-modal-btn" onClick={onClose}>&times;</button>
                <div className="rating-modal-header">
                    <h2>Sua Experiência</h2>
                    <p>Como foi seu atendimento com <strong>{appointment.barber}</strong>?</p>
                </div>

                <form onSubmit={handleSubmit} className="rating-form">
                    <div className="star-rating">
                        {[...Array(5)].map((star, index) => {
                            index += 1;
                            return (
                                <button
                                    type="button"
                                    key={index}
                                    className={index <= (hover || rating) ? "star-on" : "star-off"}
                                    onClick={() => setRating(index)}
                                    onMouseEnter={() => setHover(index)}
                                    onMouseLeave={() => setHover(rating)}
                                >
                                    <span className="star">{index <= (hover || rating) ? '★' : '☆'}</span>
                                </button>
                            );
                        })}
                    </div>

                    <div className="rating-label">
                        {getRatingLabel(hover || rating)}
                    </div>

                    <div className="rating-input-group">
                        <label htmlFor="comment">Comentário (opcional)</label>
                        <textarea
                            id="comment"
                            placeholder="Conte-nos brevemente o que você achou..."
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            maxLength={200}
                        />
                        <span className="char-count">{comment.length}/200</span>
                    </div>

                    <button
                        type="submit"
                        className="submit-rating-btn"
                        disabled={isSubmitting || rating === 0}
                    >
                        {isSubmitting ? 'Enviando...' : 'Enviar Avaliação'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ModalAvaliacao;
